import { styled } from "@mui/material/styles";

export const FooterContainer = styled("footer")(({ theme }) => ({
  position: "relative",
  overflow: "hidden",
  backgroundColor: "#252D2B",
  color: "#fff",
  padding: "112px 24px 112px",

  [theme.breakpoints.up("lg")]: {
    paddingLeft: "128px",
    paddingRight: "128px",
  },
}));

export const FooterLogo = styled("img")(({ theme }) => ({
  display: "block",
  width: "200px",
  margin: "0 auto 32px",

  [theme.breakpoints.up("lg")]: {
    marginLeft: 0,
    marginRight: "auto",
  },
}));

export const SocialLinks = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  gap: "20px",
  width: "144px",
  margin: "0 auto 80px",

  [theme.breakpoints.up("lg")]: {
    marginLeft: 0,
    marginRight: "auto",
  },
}));

export const SocialIcon = styled("a")(({ theme }) => ({
  alignItems: "center",
  borderRadius: "9999px",
  display: "grid",
  height: "2rem",
  justifyContent: "center",
  width: "2rem",
  backgroundColor: "#68D75A",
  color: "#252D2B",
  transition: "all 0.3s cubic-bezier(0.4, 0, 1, 1)",

  "&:hover": {
    transform: "translateY(-2px)",
  },

  "& svg": {
    width: "1rem",
    height: "1rem",
    display: "block",
  },
}));

export const FooterContent = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",

  [theme.breakpoints.up("xl")]: {
    flexDirection: "row",
  },
}));

export const ContactSection = styled("div")(({ theme }) => ({
  position: "relative",
  display: "inline-grid",
  width: "100%",
  gridTemplateColumns: "1fr",
  gap: "40px",
  marginBottom: "48px",
  color: "#fff",
  paddingRight: "120px",

  [theme.breakpoints.up("lg")]: {
    width: "auto",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    columnGap: "80px",
  },
}));

export const Address = styled("address")(({ theme }) => ({
  width: "100%",
  margin: 0,
  fontStyle: "normal",
  paddingBottom: "20px",
  textAlign: "center",

  [theme.breakpoints.up("lg")]: {
    textAlign: "left",
  },
}));

export const ContactDetails = styled("div")(({ theme }) => ({
  width: "100%",
  textAlign: "center",

  [theme.breakpoints.up("lg")]: {
    textAlign: "left",
  },

  "& address": {
    margin: 0,
    fontStyle: "normal",
    width: "100%",
  },

  "& p": {
    margin: 0,
    paddingBottom: "20px"
  },

  "& p + p": {
    marginTop: 0,
  },

  "& a": {
    fontWeight: 700,
    color: "white",
    textDecoration: "none",

    "&:hover": {
      color: "#68D75A"
    },
  },

}));

export const DesktopDivider = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: "40%",
  display: "none",
  flexDirection: "column",
  alignItems: "center",

  [theme.breakpoints.up("lg")]: {
    display: "flex",
  },
}));

export const DividerBall = styled("div")(({ theme }) => ({
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  backgroundColor: "#68D75A",
}));

export const DividerLine = styled("div")(({ theme }) => ({
  width: "2px",
  height: "100vh",
  backgroundColor: "#68D75A"
}));

export const FooterLinks = styled("div")(({ theme }) => ({
  display: "inline-grid",
  gap: "1.5rem",
  columnGap: "5rem",
  gridAutoFlow: "column",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  gridTemplateRows: "repeat(4, minmax(0, 1fr))",
  height: "min-content",
  position: "relative",
  textAlign: "center",
  paddingLeft: "100px",

  "& a": {
    color: "#fff",
    textDecoration: "none",
    transition: "color 0.3s ease",
    fontWeight: 700,

    "&:hover": {
      color: "#68D75A"
    },
  },
}));

export const MobileDivider = styled("div")(({ theme }) => ({
  position: "absolute",
  left: "50%",
  top: 0,
  flexDirection: "column",
  height: "100%",
  transform: "translateX(-50%)",
  color: theme.palette.text.secondary,
  display: "none",
}));

export const MobileDividerLine = styled("div")({
  flexGrow: 1,
  width: "1px",
  margin: "0 auto",
  backgroundColor: "currentColor",
});

export const AccreditationSection = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  marginBottom: "40px",

  [theme.breakpoints.up("xl")]: {
    marginBottom: 0,
  },
}));

export const AccreditationRow = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: "20px",
});

export const CyberBadge = styled("img")({
  width: "96px",
});

export const UkasBadge = styled("img")({
  width: "96px",
  height: "96px",
});

export const AccreditationNumbers = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: "20px",
  marginBottom: "40px",
  textAlign: "right",
  color: "white",
  paddingBottom: "10px",
  "& p": {
    margin: 0,
  },
}));

export const HorizontalDivider = styled("div")(({ theme }) => ({
  position: "absolute",
  left: "-40px",
  bottom: 0,
  display: "none",
  flexDirection: "row",
  alignItems: "center",

  [theme.breakpoints.up("xl")]: {
    display: "flex",
  },
}));

export const HorizontalLine = styled("div")(({ theme }) => ({
  width: "50vw",
  height: "2px",
  backgroundColor: "#68D75A"
}));

export const FooterBottom = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
  gap: "32px",
  textAlign: "center",

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    justifyContent: "space-between",
  },

  "& p": {
    margin: 0,
    fontWeight: 700,
    color: "white",
  },

  "& a": {
    fontWeight: 700,
    color: "white",
    textDecoration: "underline",

    "&:hover": {
      color: "#68D75A",
      textDecoration: "none",
    },
  },
}));